import React, { useEffect, Fragment } from "react";
import { useDispatch } from "react-redux";
import Slider from "../../components/Slider";
import SliderModels from "../../components/SliderModels";
import Stage from "../../components/Stage";
import Header from "../../components/layout/Header";
import Banner from "../../components/Banner";

import {
  getCategoriasR as getCats,
  getAllArticulos as getArts,
  jsonDeserialize,
} from "../../API/request";
import Loading from "../../components/Loading";
import MainStage from "../../components/MainStage";
import CollectionStage from "../../components/CollectionStage";

import { fetchArts } from "../../redux/slices/articulosSlice";

const Home = () => {
  const showPrice = process.env.REACT_APP_SHOW_PRICE === "false" ? false : true;
  const showBanner =
    process.env.REACT_APP_SHOW_BANNER === "false" ? false : true;

  const [showLoading, setShowLoading] = React.useState(true);
  const [listadoCategorias, setListadoCategorias] = React.useState(null);

  const [listadoNuevos, setListadoNuevos] = React.useState([]);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchArts());
  }, [dispatch]);

  useEffect(() => {
    document.title = "Home";
    window.scrollTo(0, 0);

    setListadoCategorias(null);
    setListadoNuevos([]);

    var generalNuevos = [];

    getCats()
      .then((responseCategorias) => {
        let cats = jsonDeserialize(responseCategorias.data.data).data;
        setListadoCategorias(cats);

        getArts()
          .then((responseArticulos) => {
            var arts = jsonDeserialize(responseArticulos.data.data).articulos
              .data;
            var item_generalNuevos = arts.filter(
              (item) => item.nuevo === "True"
            );

            generalNuevos.push.apply(generalNuevos, item_generalNuevos);

            setListadoNuevos(generalNuevos);
            setShowLoading(false);
            window.scrollTo(0, 0);
          })
          .catch((errorMessageGetMantenimiento) => {
            console.log("ERORR - En la petición");
          });
      })
      .catch((errorMessageGetMantenimiento) => {
        console.log("ERORR - En la petición");
      });
  }, [setShowLoading, setListadoCategorias, setListadoNuevos]);

  return (
    <Fragment>
      {showLoading ? (
        <Loading />
      ) : (
        <>
          <Header />
          <div className="content">
            <MainStage />

            <SliderModels title="Modelos" articulos={listadoCategorias} />

            {showBanner && <Banner />}

            <div className="row row-cols-3">
              <CollectionStage image={"/banner/acc_diseno.jpg"} />
              <CollectionStage image={"/banner/acc_transporte.jpg"} />
              <CollectionStage image={"/banner/acc_proteccion.jpg"} />
            </div>

            <Stage image={"banner/acc_diseno.jpg"} />
            <Stage image={"banner/acc_transporte.jpg"} />
            <Stage image={"banner/acc_proteccion.jpg"} />

            {listadoNuevos.length > 0 && (
              <Slider
                title="Nuevos"
                articulos={listadoNuevos}
                showPrice={showPrice}
              />
            )}
          </div>
        </>
      )}
    </Fragment>
  );
};

export default Home;
